<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-add-folder`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.182 5h13.16c.647 0 1.261.312 1.676.85L21.44 9h22.115C44.906 9 46 10.015 46 11.267v29.466C46 41.985 44.906 43 43.556 43H4.444C3.094 43 2 41.985 2 40.733V7.364C2 6.058 2.977 5 4.182 5zM42 39H6V13h36v26zM22 19v5h-5a1 1 0 00-1 1v2a1 1 0 001 1h5v5a1 1 0 001 1h2a1 1 0 001-1v-5h5a1 1 0 001-1v-2a1 1 0 00-1-1h-5v-5a1 1 0 00-1-1h-2a1 1 0 00-1 1z"/></svg>
</template>
<script>

export default {
  name: 'IconAddFolder',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
